import React from 'react'
import { string, number, arrayOf, shape, func } from 'prop-types'
import useFamilyGroupCard from './useFamilyGroupCard'
import SimpleCard from './SimpleCard'
import CreateGroupCard from './CreateGroupCard'
import EditGroupCard from './EditGroupCard'
import InviteGroupCard from './InviteGroupCard'

const cardProps = {
  'ask-parent': {
    headingFallback: 'Share stories with your family',
    headingKey: 'familygroups.card.askParent.heading',
    descriptionFallback:
      "You don't have any family groups to share with yet. <strong>Ask your parent to add you to a group so you can share your story!</strong>",
    descriptionKey: 'share.noGroupsYet.child',
  },
  'not-admin-enable-group-tree': {
    headingFallback: 'Enable shared living memories',
    headingKey: 'create-family-group-prompt.enable-living-memories',
    descriptionFallback:
      'Your current Family Group does not currently allow for shared living memories. <strong>Ask a group admin to enable these features in the group settings.</strong>',
    descriptionKey: 'familygroups.card.notAdminEnableGroupTree.description',
  },
  pending: {
    headingFallback: 'Waiting for Admin Approval',
    headingKey: 'familygroups.card.pending.heading',
    buttonFallback: 'Send a Reminder',
    buttonKey: 'familygroups.card.pending.button',
    descriptionFallback:
      "You've requested to join a Family Group. Reach out to a group admin to remind them to approve your request.",
    descriptionKey: 'familygroups.card.pending.description',
  },
}

export default function FamilyGroupCardFactory({ familyGroups, refreshGroups }) {
  const { cardType, targetFamilyGroup } = useFamilyGroupCard(familyGroups)

  if (cardType === 'ask-parent' || cardType === 'not-admin-enable-group-tree') {
    return <SimpleCard {...cardProps[cardType]} />
  }

  switch (cardType) {
    case 'create-group':
      return <CreateGroupCard refreshGroups={refreshGroups} />
    case 'enable-group-tree':
      return <EditGroupCard familyGroup={targetFamilyGroup} refreshGroups={refreshGroups} />
    case 'invite-members':
      return <InviteGroupCard familyGroup={targetFamilyGroup} />
    case 'pending':
      return <SimpleCard {...cardProps[cardType]} />
    default:
      return null
  }
}

export const familyGroupsPropType = arrayOf(
  shape({
    id: string,
    name: string,
    description: string,
    memberCount: number,
    memberStatus: string,
    types: arrayOf(string),
  })
)

FamilyGroupCardFactory.propTypes = {
  familyGroups: familyGroupsPropType,
  refreshGroups: func.isRequired,
}
